(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7986],{

/***/ 67639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ twilio_engage; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(46255);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(9286);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(85290);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/Hero/Hero.tsx









var copy = {
  overline: "Twilio Engage",
  heading: "Build data-driven, personalized customer experiences that grow lifetime value",
  description: "Deepen customer relationships and efficiently grow your brand by personalizing customer interactions on every channel from a unified, data-first multichannel marketing solution."
};
var FORM_ID = "engage-demo-request";

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          tag: "h5",
          variant: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            isProgressive: true,
            customFormIdentifier: FORM_ID,
            customTrackingType: FORM_ID,
            successMessageAppearance: "twilioLight"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "720",
            height: "611",
            src: (Hero_2x_default()),
            alt: "Twilio Engage",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e61ly60"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/FaqSection/FaqSection.tsx







var faqData = [{
  question: "What do customer engagement tools, like Twilio Engage, allow me to do?",
  answer: "Customer engagement tools are a piece of software that monitors, manages, and enables interactions - from website engagement to support requests - in a single platform. They allow businesses to have a view of the entire customer experience in one place, and orchestrate personalized responses based on the behavior and profile of a user."
}, {
  question: "What features should I look for in customer engagement software?",
  answer: "Identity resolution, cross channel tracking, robust integrations and the ability to build and activate a customer profile for personalized campaigns are some of the top requirements for an omnichannel customer engagement tool."
}];
var FaqSection_copy = {
  heading: "Frequently asked questions"
};

var FaqSection = function FaqSection() {
  var items = new Array(faqData.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: FaqSection_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* JsonLdFaq */.yD, {
        data: faqData.map(function (_ref) {
          var answer = _ref.answer,
              question = _ref.question;
          return {
            question: question,
            answer: answer
          };
        })
      }), activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                tag: "h3",
                opened: active,
                children: faqData[index].question
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: faqData[index].answer
              })
            })
          })]
        }, "item-".concat(index));
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1bgrnqb1"
} : 0)("padding-bottom:28px;text-align:center;margin-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:44px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1bgrnqb0"
} : 0)("max-width:1004px;overflow-x:unset;", Section/* Wrapper */.im, "{padding-top:0;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("xs");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var FaqSection_FaqSection = (FaqSection);
// EXTERNAL MODULE: ./src/views/TwilioEngage/assets/OgTwilioEngage.png
var OgTwilioEngage = __webpack_require__(91810);
var OgTwilioEngage_default = /*#__PURE__*/__webpack_require__.n(OgTwilioEngage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/TwilioEngage.tsx












var UnifiedCustomerExperiences = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(9550), __webpack_require__.e(9600), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 27113));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(27113)];
    }
  }
});
var EngageInRealTime = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(4225)]).then(__webpack_require__.bind(__webpack_require__, 64225));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64225)];
    }
  }
});
var GainCompleteViewOfYourCustomers = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(582)]).then(__webpack_require__.bind(__webpack_require__, 20582));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(20582)];
    }
  }
});
var OrchestrateJourneys = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(5054)]).then(__webpack_require__.bind(__webpack_require__, 65054));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(65054)];
    }
  }
});
var EngageCustomers = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(1257)]).then(__webpack_require__.bind(__webpack_require__, 71257));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(71257)];
    }
  }
});
var AiDrivenCustomer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(3257)]).then(__webpack_require__.bind(__webpack_require__, 73257));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(73257)];
    }
  }
});
var UseCasesDriveGrowth = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3379), __webpack_require__.e(9550), __webpack_require__.e(9600), __webpack_require__.e(2720)]).then(__webpack_require__.bind(__webpack_require__, 41914));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41914)];
    }
  }
});
var Testimonial = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7079), __webpack_require__.e(1385), __webpack_require__.e(814), __webpack_require__.e(998)]).then(__webpack_require__.bind(__webpack_require__, 20998));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(20998)];
    }
  }
});
var GettingStarted = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(442), __webpack_require__.e(5124)]).then(__webpack_require__.bind(__webpack_require__, 42576));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(42576)];
    }
  }
});
var Video = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1213).then(__webpack_require__.bind(__webpack_require__, 61213));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61213)];
    }
  }
});
var Resources = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4881), __webpack_require__.e(7243)]).then(__webpack_require__.bind(__webpack_require__, 37243));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37243)];
    }
  }
});

var TwilioEngageView = function TwilioEngageView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Engage: The Omnichannel Customer Engagement Tool | Twilio Segment",
      pageDescription: "Twilio Engage empowers marketers to drive brand growth, build and optimize personalized omnichannel campaigns and better engage customers for acquisition, conversion, and retention. ",
      pageOG: (OgTwilioEngage_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnifiedCustomerExperiences, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EngageInRealTime, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GainCompleteViewOfYourCustomers, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrchestrateJourneys, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EngageCustomers, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiDrivenCustomer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_FaqSection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCasesDriveGrowth, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e51pxyi0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var TwilioEngage_TwilioEngage = (TwilioEngageView);
;// CONCATENATED MODULE: ./src/pages/product/twilio-engage.tsx



var TwilioEngage = function TwilioEngage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwilioEngage_TwilioEngage, {});
};

/* harmony default export */ var twilio_engage = (TwilioEngage);

/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 79540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/twilio-engage",
      function () {
        return __webpack_require__(67639);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91810:
/***/ (function(module) {

module.exports = "/_next/static/images/OgTwilioEngage-0272665d01e30b9ab5898a5497925c7a.png";

/***/ }),

/***/ 46255:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-63097beec02b75e7ed859cac77c929c3.png";

/***/ }),

/***/ 9286:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-eeb0acf18ce3e166086125be0c1e09a7.webp";

/***/ }),

/***/ 85290:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-f376af8d94718a36777f153fb9d00453.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,2472,7357,9774,2888,179], function() { return __webpack_exec__(79540); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);